import { createSlice } from "@reduxjs/toolkit";
import {
  addRole,
  deleteRole,
  getAllRoles,
  getRoleDetails,
  getRolesList,
  updateRole,
  updateRoleStatus,
} from "store/actions/rolesSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  roles: [],
  roleDetails: {},
  rolesList: [],
  gettingDetails: false,
};

const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRoles.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        const { data, totalCount, totalPages, currentPage } =
          action.payload || {};
        if (success) {
          state.roles = data;
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllRoles.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getRolesList.pending, (state) => {})
      .addCase(getRolesList.fulfilled, (state, action) => {
        const { success } = action.payload || {};
        const { data } = action.payload || {};
        if (success) {
          state.rolesList = data;
        }
      })
      .addCase(getRolesList.rejected, (state, action) => {});

    builder
      .addCase(getRoleDetails.pending, (state) => {
        state.gettingDetails = true;
      })
      .addCase(getRoleDetails.fulfilled, (state, action) => {
        state.gettingDetails = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.roleDetails = data;
        }
      })
      .addCase(getRoleDetails.rejected, (state, action) => {
        state.gettingDetails = true;
      });

    builder
      .addCase(addRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addRole.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.roles.push(data);
        }
      })
      .addCase(addRole.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.roles = state?.roles?.map((item) =>
            item._id === data._id ? data : item
          );
        }
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteRole.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        const { success } = action.payload;
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.roles = state.roles.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateRoleStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRoleStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success } = action.payload || {};
        if (success) {
          const { id, status } = action.meta.arg;
          state.roles = state?.roles?.map((item) =>
            item._id === id ? { ...item, status: status } : item
          );
        }
      })
      .addCase(updateRoleStatus.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default rolesSlice.reducer;
